<template>
  <div class="index-modular">
    <MyHeader ref="headerModular" :number="cartNum"></MyHeader>
    <HeaderMenu ref="headerMenuModular"></HeaderMenu>
    <ShareRight></ShareRight>
    <router-view />

    <!-- <div class="footer-modualr"> -->
    <MyFooter></MyFooter>
    <!-- </div> -->
  </div>
</template>
<script>
import MyHeader from "../components/public/header";
import ShareRight from "../components/public/publicRight";
import MyFooter from "../components/public/footer";
import HeaderMenu from "../components/public/headerMenu";

export default {
  components: {
    MyHeader,
    ShareRight,
    MyFooter,
    HeaderMenu,
  },
  data() {
    return {
      cartNum: 0,
      pageTextArr: [
        "您还没有登录，请先登录",
        "确定",
        "已添加到您的购物车，请在您的购物车进行查阅",
      ],
    };
  },
  methods: {
    // getUserInfo() {
    //   console.log("getUserInfo");
    // },
    /**
     * 更改购物车的数量
     */
    setHeaderCartNum(num) {
      let that = this;
      this.$refs.headerModular.shopCartNum = num;
      // if (localStorage.getItem("isLogin") == 1) {
      //   this.$refs.headerModular.shopCartNum = num;
      // }
    },

    /**
     * 更新用户头像和名称
     */
    updateUserInfo() {
      this.$refs.headerModular.getUserInfo();
    },

    /**
     *  加入购物车
     * @param {*} product_id
     * @param {*} sku_number
     * @param {*} type
     * @param {*} portfolio_sales_middle_id
     * @param {*} cartNum
     */
    addCart(product_id, sku_number, type, portfolio_sales_middle_id, cartNum) {
      let that = this;
      // let cookie = that.getCookie()
      // if(cookie == null || cookie == ""){
      //    that.setCookie("cookie")
      //    cookie = that.getCookie("cookie")
      // }

      let data = {
        product_id: product_id,
        sku_number: sku_number,
        type: type,
        portfolio_sales_middle_id: portfolio_sales_middle_id,
        cartNum: cartNum, //购物车数量
        cookie: that.getCookies(),
      };
      this.$http.addCart(
        data,
        (res) => {
          if (res.ret == 1) {
            // this.$message.success(res.msg);
            this.$message.success(this.pageTextArr[2]);
            // this.$refs.headerModular.shopCartNum ++;
            // 查询购物车数量
            that.getCartNum();
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     *
     * @param {*} id
     * @param {*} type 0-加入收藏 1-取消收藏
     */
    productCollect(id, type, callback) {
      let that = this;
      let data = {
        product_id: id,
      };
      let status = false;
      let collectAjaxUrl = this.$http.addCollect;
      if (type == 0) {
        // 加入收藏
        collectAjaxUrl = this.$http.addCollect;
      } else {
        // 取消收藏
        collectAjaxUrl = this.$http.cancelCollect;
      }
      collectAjaxUrl(data, callback, callback);
    },

    /**
     *
     * @param {*} id
     */
    cancelCollect(id) {
      let that = this;
      let data = {
        product_id: id,
      };
      let status = false;
      this.$http.cancelCollect(
        data,
        (res) => {
          if (res.ret == 1) {
            status = true;
            this.$message.success(res.msg);
          } else {
            status = false;
            this.$message.error(res.msg);
          }
        },
        (res) => {
          status = false;
          this.$message.error(res.msg);
        }
      );
      return status;
    },

    /**
     * 获取购物车的数量
     */
    getCartNum() {
      let that = this;
      let status = false;
      let data = {
        cookie: that.getCookies(),
      };
      // if (localStorage.getItem("isLogin") != 1) return;
      this.$http.getCartNum(
        data,
        (res) => {
          if (res.ret == 1) {
            that.setHeaderCartNum(parseInt(res.data.cartCount));
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
      return status;
    },
    /**
     * 设置默认菜单
     */
    setHeaderActive() {
      let that = this;
      if (this.$route.path == "/") {
        that.$refs.headerMenuModular.activeIndex = 0;
      } else {
        let menuActiveIndex = localStorage.getItem("menuActiveIndex");
        that.$refs.headerMenuModular.activeIndex =
          menuActiveIndex == null ? 1 : menuActiveIndex;
      }
    },

    /**
     * 提示登录
     */
    tipsLogin() {
      if (localStorage.getItem("isLogin") != 1) {
        this.$alert(this.pageTextArr[0], "", {
          distinguishCancelAndClose: true,
          confirmButtonText: this.pageTextArr[1],
        })
          .then(() => {
            this.$router.push({
              path: "/login",
            });
          })
          .catch((action) => {
            //
          });
        return true;
      }
    },

    /**
     * 语言翻译 - 单个
     * @param {*} text
     * @param {*} callback
     * @param {*} errCallBack
     */
    translate(text, callback, errCallBack) {
      let that = this;
      let data = {
        text: text, //带翻译文本
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translate(data, callback, errCallBack);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     * @param {*} callback
     * @param {*} errCallBack
     */
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr) {
      let that = this;
      let newpagetextArr = [];
      that.translateByArr(arr, (res) => {
        console.log("res", res);
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation);
        });
        that.pageTextArr = newpagetextArr;
      });
    },
  },
  mounted() {
    let that = this;
    // 选中产品菜单
    that.setHeaderActive();
    // console.log('index',this.$refs.headerMenuModular.activeIndex);
    // 查询购物车数量
    that.getCartNum();
    //
    // that.languageTranslate('及时反馈');
    that.languageTranslateByArrs(that.pageTextArr);
  },
};
</script>


<!-- Chatra {literal} -->
<!-- <script>
   (function(d, w, c) {
      w.ChatraID = 'X5hbB6MxYos4jt9vc';
      var s = d.createElement('script');
      w[c] = w[c] || function() {
         (w[c].q = w[c].q || []).push(arguments);
      };
      s.async = true;
      s.src = 'https://call.chatra.io/chatra.js';
      if (d.head) d.head.appendChild(s);
   })(document, window, 'Chatra');
</script> -->
<!-- /Chatra {/literal} -->
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/view/index.vue